import React from 'react';
import BackIconComponent from "../../components/GipDownload/Components/BackIconComponent";
import Images from "../../assets/images/Images";
import GipDownloadContent from "../../components/GipDownload/GipContentDownloadContent";

const GipDownloadContainer: React.FC = () => {
    return (
        <div className='downloadContainer'>
            <div style={{flex: 1, zIndex: 2}}>
                <BackIconComponent />
            </div>
            <div style={{flex: 10, display: 'flex'}}>
                <div className='imageWrapper'>
                    <img src={Images.homeImage1} style={{height: 450, position: 'relative', left: '25%', top: '5%'}} />
                </div>

                <div className='contentWrapper'>
                    <GipDownloadContent />
                </div>
            </div>
        </div>
    );
};

export default GipDownloadContainer;
